/* eslint-disable jsx-a11y/iframe-has-title */
import { pdfViewerStyle } from './pdfViewerStyle';

const getPdf = (oldPDF?: boolean) => `https://drive.google.com/viewerng/viewer?embedded=true&url=${(
  oldPDF
    ? process.env.REACT_APP_URL_TERMS_CONDITION
    : process.env.REACT_APP_URL_TERMS_CONDITION_2024
)}#toolbar=0&scrollbar=0`;

interface Props {
  oldPDF?: boolean;
}

export const PdfViewer = (props: Props) => {
  const { oldPDF } = props;
  return (
    /*
    Create a static HMTL component
    */
    <iframe
      src={getPdf(oldPDF)}
      frameBorder="0"
      scrolling="auto"
      height="100%"
      width="100%"
      style={pdfViewerStyle.containerPdf}
    >
      <p>Este navegador no soporta PDF!</p>
    </iframe>
  );
};
